import React, { useContext, useEffect } from "react";
import HeaderWithButton from "../Utility/HeaderWithButton";
import { Dialog } from "@headlessui/react";
import { useState } from "react";
import LeadRoleAssignList from "./LeadRoleAssignList";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import HeaderWithAction from "../Utility/HeaderWithAction";
import { DataContext } from "../../helper/HelperOne";

function LeadRoleAssignCreate() {
  const user = JSON.parse(localStorage.getItem("user"));
  const rolesAssignPermission = user?.settings_role_based_access?.some(
    (access) => access.label_id == 10 && access.label_value != 0
  );
    const { searchData } = useContext(DataContext);

  const [isLeadRoleAssignDialogOpen, setIsLeadRoleAssignDialogOpen] =
    useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [roleAssignInputsList, setRoleAssignInputsList] = useState({});
  const [paginationRoleAssignData, setPaginationRoleAssignData] = useState([]);
  const [leadRollAssignDatas,setLeadRollAssignDatas]=useState([]);
  const [rollAssignDatas, setRollAssignDatas] = useState([]);
  const [rollsData, setRollsData] = useState([]);
  const [saveBtn, setSaveBtn] = useState("save");
  const [currentPage, setCurrentPage] = useState(1);
  const [employees, setEmployees] = useState([]);
  const [editIdCryptForRollAssign, seteditIdCryptForRollAssign] =
    useState(null);
  const [loading, setLoading] = useState(false);
  const [paginationLeadRoleAssign, setPaginationLeadRoleAssign] = useState([]);

  const [formData, setFormData] = useState({
    employee_id: "",
    role_id: "",
    status_id: "",
  });
    const [leadRoleAssignData, setLeadRoleAssignData] = useState([]);

  const fetchRollAssignData = async (page=1) => {
    try {
        const responseForRolls = await axios.get("public/api/admin/leadrole ", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        });
        
        setRollsData(responseForRolls.data.role)
        const responseForEmployees = await axios.get("public/api/admin/employees", {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        });
  
        setEmployees(responseForEmployees.data.employee)
        
        const apiUrl = searchData
        ? `public/api/admin/leadroleassign/pagination?page=${page}&search=${searchData}`
        : `public/api/admin/leadroleassign/pagination?page=${page}`;

    const response = await axios.get(apiUrl, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });



    setLeadRoleAssignData(response.data.roleassign.data);
    setPaginationLeadRoleAssign(response.data.roleassign);

    
        setLeadRoleAssignData(response.data.roleassign || []);

    } catch (error) {
        
    }
  };

  useEffect(() => {
    fetchRollAssignData();
  }, [searchData]);

  const handleAddRollAsign = () => {
    setIsLeadRoleAssignDialogOpen(true);
    setFormData({ employee_id: "", role_id: "", status_id: "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    try {
        const response =await axios.post("public/api/admin/leadroleassign/store", formData,{
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if(response.data){
            toast.success(response.data.message);
            setIsLeadRoleAssignDialogOpen(false); 
            await fetchRollAssignData();
        }
    } catch (error) {
        toast.error(error.response.data.message);
    } finally{
        setLoading(false);
    }
  };

  // Handle update action (API call or UI update)
  const handleUpdate = async(e) => {
    setSaveBtn("update");
    e.preventDefault();
    const token = localStorage.getItem("token");
    try {
        const response = await axios.put(`public/api/admin/leadroleassign/update/${editIdCryptForRollAssign}`, formData,{
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
  
    
            toast.success(response.data.message);
            setIsLeadRoleAssignDialogOpen(false);
            await fetchRollAssignData();
       
    } catch (error) {
        toast.error(error.response?.data?.message);
    } finally{
        setLoading(false);
    }
  };

  const handleDialogClose = async () => {
    setIsLeadRoleAssignDialogOpen(false);
  };


  return (
    <>
      <HeaderWithButton
        title="Role Assign"
        description="role assign"
        buttonText="Role Assign"
        onButtonClick={handleAddRollAsign}
        showButton={rolesAssignPermission}

      />

      <LeadRoleAssignList
        isEditing={isEditing}
        setRoleAssignInputsList={setRoleAssignInputsList}
        paginationRoleAssignData={paginationRoleAssignData}
        setIsLeadRoleAssignDialogOpen={setIsLeadRoleAssignDialogOpen}
        setRollAssignDatas={setRollAssignDatas}
        rollAssignDatas={rollAssignDatas}
        setSaveBtn={setSaveBtn}
        fetchRollAssignData={fetchRollAssignData}
        setCurrentPage={setCurrentPage}
        seteditIdCryptForRollAssign={seteditIdCryptForRollAssign}
        setLeadRollAssignDatas={setLeadRollAssignDatas}
        setLoading={setLoading}
        setFormData={setFormData}
        leadRoleAssignData={leadRoleAssignData}
        rolesAssignPermission={rolesAssignPermission}
        paginationLeadRoleAssign={paginationLeadRoleAssign}
      />

      {/* <Transition appear show={isOpen} as={Fragment}> */}
      {isLeadRoleAssignDialogOpen && (
        <Dialog
          as="div"
          className="relative z-50"
          open={isLeadRoleAssignDialogOpen}
          onClose={() => setIsLeadRoleAssignDialogOpen(false)}
        >
          {/* Overlay */}
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

          {/* Dialog Panel Container */}
          <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center md:min-h-screen sm:p-0">
              {/* Dialog Panel */}
              <Dialog.Panel className="relative bg-white rounded-lg shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto">
                {/* Header
                <div className="flex justify-between items-center  border-b p-4" style={{ backgroundColor: '#6366f1' }}>
              <Dialog.Title className="text-lg font-medium text-white">
                NEW ROLE ASSIGN
              </Dialog.Title>
              <button className="text-white " onClick={() => setIsLeadRoleAssignDialogOpen(false)}>
                <svg className="w-6 h-6" fill="none" stroke="white" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div> */}

                <HeaderWithAction
                  title="ROLL ASSIGN INFO"
                  handleClose={handleDialogClose}
                  isEditing={isEditing}
                />

                {/* Form Content */}
                <div className="p-6">
                  <form>
                    <div className="grid grid-cols-6 gap-6">
                      {/* Employee Name */}
                      <div className="col-span-6 sm:col-span-2">
                        <label className="block text-sm uppercase font-medium text-gray-900 text-left">
                          Employee Name<span className="text-red-500">*</span>
                        </label>
                        <select
                          name="employee_id"
                          value={formData.employee_id}
                          onChange={handleChange}
                          className="mt-2 block uppercase w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        >
                          <option value="">Select Employee</option>
                          {employees.map((employee) => (
                            <option
                              key={employee.id}
                              value={employee.id}
                            >{employee.name}</option>
                          ))}
                        
                        </select>
                      </div>

                      {/* Role Name */}
                      <div className="col-span-6 sm:col-span-2">
                        <label className="block uppercase text-sm font-medium text-gray-900 text-left">
                          Role Name<span className="text-red-500">*</span>
                        </label>
                        <select
                          name="role_id"
                          value={formData.role_id}
                          onChange={handleChange}
                          className="mt-2 block uppercase w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        >
                          <option value="">Select Role</option>
                          {rollsData?.map((roll) => (
                            <option
                              key={roll.id}
                              value={roll.id}
                            >{roll.name}</option>
                          ))}
                        </select>
                      </div>

                      {/* Status */}
                      <div className="col-span-6 sm:col-span-2">
                        <label className="block uppercase text-sm font-medium text-gray-900 text-left">
                          Status<span className="text-red-500">*</span>
                        </label>
                        <select
                          name="status_id"
                          value={formData.status_id}
                          onChange={handleChange}
                          className="mt-2 block w-full uppercase rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        >
                          <option value="">Select Status</option>
                          <option value="1">Active</option>
                          <option value="0">Deactivated</option>
                        </select>
                      </div>
                    </div>

                    {/* Footer */}
                    <div className="mt-6 text-right">
                     {saveBtn ==="save" ?<button
                        onClick={handleSubmit}
                        className="px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-md hover:bg-indigo-700 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      >
                        Save
                      </button> :
                      <button
                      onClick={handleUpdate}
                      
                      className="px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded-md hover:bg-indigo-700 focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Update
                    </button>
                      } 
                    </div>
                  </form>
                </div>
              </Dialog.Panel>
            </div>
          </div>
        </Dialog>
      )}
      {/* </Transition> */}
    </>
  );
}

export default LeadRoleAssignCreate;
